import React from 'react';
import MainMenu from './components/MainMenu';
import Home from './sections/Home';
import Company from './sections/Company';
import Products from './sections/Products';
import Engineering from './sections/Engineering';
import Procurement from './sections/Procurement';
import Projects from './sections/Projects';
import Quality from './sections/Quality';
import News from './sections/News';
import Contacts from './sections/Contacts';
import { Route } from 'react-router-dom';
import Helmet from 'react-helmet';

const components = [
  Home,
  Company,
  Products,
  Engineering,
  Procurement,
  Projects,
  Quality,
  News,
  Contacts
]
export default () => (
  <div className="app">
    <Helmet title="ARTechnology"/>
    <Route path='/' component={ MainMenu } />
    <div className='sections-container'>
    {
      components.map( ( comp, i ) => (
        <Route key={ i } path='/' component={ comp } />
      ))
    }
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/Main.js